import { apiSlice } from "./apiSlice";
import { COMPANY_URL } from "../constants";

const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Zutle only: creates the company together with its primary owner
    // (data.owner). The server checks zutleSecret against
    // CREATE_COMPANY_SECRET; it is sent as a header, never in the body.
    createCompany: builder.mutation({
      query: ({ zutleSecret, ...data }) => ({
        url: `${COMPANY_URL}/createCompany`,
        method: "POST",
        body: data,
        headers: {
          "x-zutle-secret": zutleSecret,
        },
      }),
    }),
    getCompanyById: builder.query({
      query: (data) => ({
        url: `${COMPANY_URL}/getMyCompany`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    editCompanyDetails: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/editCompanyDetails`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    uploadCompanyPhoto: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/uploadCompanyPhoto`,
        method: "POST",
        body: data.payload,
        // No token during registration (the company has no admin yet);
        // once it has one, the server requires that super admin's token.
        ...(data.token && {
          headers: { Authorization: `Bearer ${data.token}` },
        }),
      }),
    }),
  }),
});

export const {
  useCreateCompanyMutation,
  useGetCompanyByIdQuery,
  useEditCompanyDetailsMutation,
  useUploadCompanyPhotoMutation,
} = companyApiSlice;
